export const EXTERNAL_FORM_RENDERER_KEYS = Object.freeze([
  "contact-popup",
  "miridar-demo-request-inline",
  "miridar-file-request-inline",
  "miridar-data-collection-inline",
]);
export const DEFAULT_EXTERNAL_FORM_RENDERER_KEY = "contact-popup";
export const INLINE_DEMO_REQUEST_RENDERER_KEY = "miridar-demo-request-inline";
export const INLINE_FILE_REQUEST_RENDERER_KEY = "miridar-file-request-inline";
// GDPR S5.3B: formularul „Colectare date”.
export const DATA_COLLECTION_RENDERER_KEY = "miridar-data-collection-inline";
export const INLINE_RENDERER_KEYS = Object.freeze([
  INLINE_DEMO_REQUEST_RENDERER_KEY, INLINE_FILE_REQUEST_RENDERER_KEY, DATA_COLLECTION_RENDERER_KEY,
]);
// Ruta publică (preview) și codul de integrare al fiecărui tip: `[eticheta i18n, câmpul widgetului]`.
export const RENDERER_WIDGET_PATHS = Object.freeze({
  [DEFAULT_EXTERNAL_FORM_RENDERER_KEY]: "/widgets/contact-popup",
  [INLINE_DEMO_REQUEST_RENDERER_KEY]: "/widgets/contact-form",
  [INLINE_FILE_REQUEST_RENDERER_KEY]: "/widgets/file-request-form",
  [DATA_COLLECTION_RENDERER_KEY]: "/widgets/data-collection-form",
});
export const RENDERER_EMBEDS = Object.freeze({
  [DEFAULT_EXTERNAL_FORM_RENDERER_KEY]: ["popupEmbedCode", "embedScript"],
  [INLINE_DEMO_REQUEST_RENDERER_KEY]: ["inlineEmbedCode", "inlineEmbedScript"],
  [INLINE_FILE_REQUEST_RENDERER_KEY]: ["fileRequestEmbedCode", "fileRequestEmbedScript"],
  [DATA_COLLECTION_RENDERER_KEY]: ["dataCollectionEmbedCode", "dataCollectionEmbedScript"],
});

export const buildInlineExternalFormEmbedScript = (formKey, target = "#miridar-demo-request") => {
  const targetId = String(target || "#miridar-demo-request").replace(/^#/, "") || "miridar-demo-request";
  return `<div id="${targetId}"></div>\n<script async src="https://app.miridar.com/widgets/contact-form.js" data-form-key="${formKey}" data-target="${target || "#miridar-demo-request"}"></script>`;
};

export const buildInlineFileRequestEmbedScript = (formKey, target = "#miridar-file-request") => {
  const targetId = String(target || "#miridar-file-request").replace(/^#/, "") || "miridar-file-request";
  return `<div id="${targetId}"></div>\n<script async src="https://app.miridar.com/widgets/file-request-form.js" data-form-key="${formKey}" data-target="${target || "#miridar-file-request"}"></script>`;
};
